import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import DynamicForm from '../common/DynamicForm/form';
import { getDynamicFormData, updateDynamicFormData } from './action';
import { jobOpportunitySelector } from './selector';

const CreateDynamicJob = (props) => {
    const { formdata, jobInfo } = useSelector(jobOpportunitySelector);
    const { errors, jobTypeId, postion, commonselctRef } = props
    const error = errors ? errors['dynamicForm'] ? errors['dynamicForm'] : {} : {};
    const dispatch = useDispatch();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const [form, setForm] = useState(formdata);
    useEffect(() => {
        if (config.baseUrl && jobInfo?.jobCategory?.id) {
            if (formdata?.length === 0 || jobInfo?.jobCategory?.id) {
                dispatch(getDynamicFormData({ url: config.baseUrl, jobLevel: [jobInfo?.jobCategory?.id] }));
            }

        }
    }, [config, jobTypeId, jobInfo?.jobCategory?.id])

    useEffect(() => {
        dispatch(updateDynamicFormData(form));
    }, [form]);

    const updateDynamicFilter = (target, type, formId, formsSectionID) => {
        const newVal = JSON.parse(JSON.stringify(formdata));
        //console.log(target, type, formId, formsSectionID);
        newVal.forEach(item => {
            if (item.formId === formId) {
                item.controlsInfo.forEach(val => {
                    if (val.formsSectionID === formsSectionID) {
                        if (type === 'ReactMultiSelectDropdown') {
                            val.selectedValueOptions = assignMultiSelectVal(target, val.selectedValueOptions);
                        }
                    }
                })
            }
        });
        setForm(newVal);
    }

    const assignMultiSelectVal = (target, selectedValueOptions) => {
        console.log(target, selectedValueOptions);
        if (target.action === 'add') {
            return [...selectedValueOptions, target.value]
        } else if (target.action === 'remove') {
            const newData = selectedValueOptions.filter(item => item.id !== target.value.id);
            return [...newData]
        }
    }

    return (
        <>
            {
                formdata?.length > 0 ?
                    formdata?.map(item => (
                        <div className="card" key={item?.formId}>
                            <div className="col-lg-12 col-md-12">
                                <div className="row">
                                    <div className="card-header">
                                        <h3 class="card-title">{item?.formNameToDisplay}</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className='row'>
                                            <DynamicForm formId={item?.formId} controlsInfo={item?.controlsInfo} errors={error ? error[item?.formId] : ''}
                                                updateDynamicFilter={updateDynamicFilter}
                                                commonselctRef={commonselctRef}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    : ''
            }
        </>
    )
}

export default CreateDynamicJob;